import React, { useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { injectIntl } from "react-intl"

import Car from "@material-ui/icons/DirectionsCar"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import Help from "@material-ui/icons/Help"
import Divider from "@material-ui/core/Divider"
import Drawer from "@material-ui/core/Drawer"
import Home from "@material-ui/icons/Home"
import IconButton from "@material-ui/core/IconButton"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"

import messages from "./messages"

const drawerWidth = 240
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: drawerWidth,
  },
}))
const Menu = ({
  handleDrawerClose,
  intl: { formatMessage },
  open,
  tenantSettings,
}) => {
  const theme = useTheme()
  const classes = useStyles()
  const menuRef = useRef(null)
  const { aboutCustomerSupportUrl } = tenantSettings

  useEffect(() => {
    const handleClickOutside = ({ target }) => {
      if (menuRef.current && !menuRef.current.contains(target) && open) {
        handleDrawerClose()
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [handleDrawerClose, menuRef, open])

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
      ref={menuRef}
    >
      <div className={classes.drawerHeader}>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>
      <Divider />
      <List>
        {[
          {
            route: "/",
            icon: <Home />,
            text: formatMessage(messages.scheduleRental),
          },
          {
            route: "/trips",
            icon: <Car />,
            text: formatMessage(messages.myTrips),
          },
          {
            ...(aboutCustomerSupportUrl && {
              href: `${aboutCustomerSupportUrl}`,
              icon: <Help />,
              text: formatMessage(messages.contactSupport),
            }),
          },
        ].map(({ icon, href, route, text }, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{icon}</ListItemIcon>
            {/* If route, render with the internal link component */}
            {route && (
              <Link to={route} onClick={handleDrawerClose}>
                <ListItemText primary={text} />
              </Link>
            )}
            {/* If href, render with the anchor tag, open in new tab */}
            {href && !route && (
              <a href={href} target="_blank" rel="noopener noreferrer">
                <ListItemText primary={text} />
              </a>
            )}
          </ListItem>
        ))}
      </List>
    </Drawer>
  )
}
export default injectIntl(Menu)
